<template>
  <div
    v-if="shouldShowInformationBar"
    class="uc-information-bar"
  >
    <div class="uc-information-bar__content">
      <PCInformationBarBlock :items="leftItems" />
      <PCInformationBarBlock :items="rightItems" />
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { useInformationBar } from '@/composables/useInformationBar';
import { watch } from 'vue';

import PCInformationBarBlock from './PCInformationBarBlock.vue';

const { leftItems, rightItems } = useInformationBar();
const { shouldShowInformationBar } = useInformationBar();

watch(shouldShowInformationBar, (newVal) => {
  document.documentElement.style.setProperty('--information-bar-height', newVal ? '38px' : '0px');
}, { immediate: true });
</script>

<style>
:root {
  --information-bar-height: 38px;
  --information-bar-color: #fff;
  --information-bar-bg-color: var(--his-blue);
  --information-bar-z-index: 99999999;
  --information-bar-padding: 0 var(--f7-typography-padding) 0 var(--f7-typography-padding);
  --information-bar-item-gap: 16px;
  --information-bar-icon-gap: 4px;
  --information-bar-overflow: hidden;
  --information-bar-text-overflow: ellipsis;
  --information-bar-white-space: nowrap;
  --information-bar-padding-bottom: var(--information-bar-height);
}

.view-main .page-current,
.view-main .page-previous {
  padding-bottom: var(--information-bar-padding-bottom);
}
</style>

<style scoped lang="scss">
.uc-information-bar {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: var(--information-bar-z-index);
  background-color: var(--information-bar-bg-color);
  color: var(--information-bar-color);
  height: var(--information-bar-height);
}

.uc-information-bar__content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: var(--information-bar-padding);
  gap: var(--information-bar-item-gap);
}
</style>
